<template>
  <el-container class="indexhome">
    <el-header>
      <img
        class="logo"
        src="../assets/logo.svg">
      <!-- <p>{{$t('global.parentTitle')}}</p> -->
    </el-header>
    <el-main>
      <!-- 设置邮箱和推荐码 -->
      <div class="email_form">
        <el-form :model="emailForm" :rules="emailValidate" ref="emailForm" label-width="100px" class="demo-emailForm">
          <h3>{{$t('email.accountInfo')}}</h3>
          <p style="margin-top:40px;">{{$t('email.emailAddress')}}</p>
          <el-form-item prop="email">
            <el-input :class="changeFlag == 1?'':'errorPass'" type="email" v-model="emailForm.email" autocomplete="off" placeholder="example@email.com"></el-input>
          </el-form-item>
          <el-button type="primary" @click="toNext()">{{$t('global.next')}}</el-button>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import store from '@/store/store'
export default {
  name: 'email',
  data () {
    const checkEmail = async (rule, value, callback) => {
      const mailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      if (!value) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.emailEmpty')))
      } else if (!mailReg.test(value)) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.emailError')))
      } else {
        this.changeFlag = 1
        callback()
      }
    }

    return {
      emailForm: {
        email: ''
      },
      emailValidate: {
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' }
        ]
      },
      changeFlag: 1
    }
  },
  created () {

  },
  methods: {
    toNext () {
      this.$refs.emailForm.validate((valid, msg) => {
        if (!valid) {
          this.$message(msg['email'][0].message)
          return false
        }
        this.$http.get('/api/postemail?email=' + this.emailForm.email).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: this.$t('errorprompt.emailBeSend'),
              type: 'success'
            })
            this.$router.push({ path: '/' })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 1200px;
    height:auto!important;
    margin: 0 auto;
  }
  .el-header{
      width: 1200px;
      height:auto!important;
      padding: 20px 0;
      font-family: Sofia Pro-Regular;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
        width: 227px;
        margin-top:5px;
        text-align: center;
      }
  }
  .el-main{
    overflow: inherit;
    padding:0;
    h3{
      font-size: 18px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #353643;
      margin-top:10px;
    }
    p{
      font-size: 16px;
      font-family: Sofia Pro-Regular;
      color: #424347;
      margin-top:6px;
    }
    .email_form{
        // width: 60%;

        // width: 398.85px;
        width: 610px;
        border: 1px solid #F4F4F4;
        box-shadow: 0, 0, 0, 0.05;

        margin: 0 auto;
        background: #fff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        .el-form {
            width: 398.85px;
            margin: 0 auto 0 auto;
            // width: 100%;
            height:100%;
            padding:40px;
            display: flex;
            flex-direction: column;

            /deep/ .el-form-item{
                .el-form-item__content{
                  display: flex;
                  margin:0!important;
                  img{
                    width: 20px;
                    height:20px;
                    margin: 0 8px;
                    position: absolute;
                    right: 0px;
                    bottom:12px;
                  }
                  .el-input{
                    // width:50%;
                    border-bottom: 1px solid #a5a5a5;
                  }
                  .errorPass{
                    border-bottom: 1px solid #a5a5a5;
                  }
                  .el-input__inner {
                    -moz-appearance: none;
                    // width:100%;
                    height: 40px;
                    border:none;
                    background: none;
                    font-size: 16px;
                    color: #353643;
                    font-family: Sofia Pro-Regular;
                    letter-spacing: 0px;
                    outline: 0;
                    padding:0 40px 0 0;
                    border-radius: 0;
                  }
                  .el-form-item__error{
                    // margin-top:7px;
                    font-size: 14px;
                    color: #fc424c;
                    font-family: Sofia Pro-Regular;
                    width: max-content;
                  }
                }
              }

        //     .huo {
        //       font-size: 16px;
        //       font-family: Sofia Pro-Bold;
        //       font-weight: 700;
        //       text-decoration: underline;
        //       text-align: LEFT;
        //       color: #ff6440;
        //       cursor: pointer;
        //       margin-top:40px;
        //       display: contents;
        //     }
            button{
              margin: 200px auto 0 auto;
              width: 190px;
              height: 40px;
              background: #4B69FE;
              border-radius: 50px;
              border: 1px solid #4B69FE;
              // margin-top: 40px;
              // margin-bottom: 15px;
              color: #fff;
              font-size: 16px;
              font-family: Sofia Pro-Bold;
              box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
            }
        //     .borderBtn{
        //         width:auto;
        //         height: 40px;
        //         background: #ffffff;
        //         border: 2px solid #ff6440;
        //         border-radius: 7px;
        //         font-size: 14px;
        //         font-family: Sofia Pro-Bold;
        //         font-weight: 700;
        //         color: #ff6440;
        //         margin: 0 20px;
        //         &:hover{
        //           background: #ffffff;
        //           border: 2px solid #ff6440;
        //           font-size: 14px;
        //           font-family: Sofia Pro-Bold;
        //           font-weight: 700;
        //           color: #ff6440;
        //         }
        //     }
            input{
              width:345px;
              height: 50px;
              border:none;
              background: none;
              font-size: 18px;
              color: #353643;
              font-family: Sofia Pro-Regular;
              letter-spacing: 0px;
            }
            input:focus {
              outline: none;
            }
          }
        }
  }

</style>



// WEBPACK FOOTER //
// src/components/emailFindPsw.vue